// =============================================================================
// ADMIN - I18N WRAPPER
// =============================================================================
// Thin wrapper around shared i18n system configured for Admin portal
// Same pattern as FAFSA, Benefits, and Parent Advocate agents
// =============================================================================

import { useTranslation as useSharedTranslation, registerLocales, type LanguageCode, SUPPORTED_LANGUAGES } from '../../../shared/i18n';
import { config } from '../../../shared/config';

// Bundle this agent's locale files at build time via Vite glob.
// Runs at module level — locales are available before any component renders.
registerLocales('admin', import.meta.glob(
  '../../../shared/i18n/locales/admin/*.json',
  { eager: true, import: 'default' }
));
// Cross-agent keys used by shared/ components (cobrowse, calendar) live in a single
// `shared` namespace so completeness is enforced once, regardless of how many agents
// import the component. Merged on top of this agent's own bundle.
registerLocales('admin', import.meta.glob(
  '../../../shared/i18n/locales/shared/*.json',
  { eager: true, import: 'default' }
));

/**
 * Hook for translations in Admin portal
 *
 * Usage:
 *   const { t, language, setLanguage } = useTranslation();
 *   <h1>{t('dashboard.title', 'Dashboard')}</h1>
 */
export function useTranslation() {
  return useSharedTranslation({
    agent: 'admin',
    apiBase: config.apiBase,
  });
}

// =============================================================================
// EXPORTS
// =============================================================================

export { SUPPORTED_LANGUAGES as LANGUAGES };
export { type LanguageCode };
export { LanguageSelector } from './LanguageSelector';
// Shared failure handler + exhaustive enum resolver (Step-0 PR-0C).
export { reportI18nMiss, tEnum } from '../../../shared/i18n';
export default useTranslation;
